import Vue from "vue";
const vm = Vue.prototype;

export const state = () => ({
  smsSettings: [],
});

export const mutations = {
  SET_SMS_SETTINGS(state, payload) {
    state.smsSettings = vm.$toArray(payload);
  },
};

export const actions = {
  async INIT_SMS_SETTINGS({ commit }) {
    const data = await vm.$axios.$get("admin/sms-settings");
    if (data) commit("SET_SMS_SETTINGS", data);
    return data;
  },

  async UPDATE_SMS_SETTING(ctx, { smsKey, enabled, template }) {
    return await vm.$axios.$put(`admin/sms-settings/${smsKey}`, { enabled, template });
  },
};

export const getters = {
  GET_SMS_SETTINGS: (state) => state.smsSettings,
};
